import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

export const References = () => {
    const { t } = useTranslation();
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 5000,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 1024, // tablet
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    centerMode: true,
                    centerPadding: "20px"
                }
            },
            {
                breakpoint: 640, // mobile
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    centerPadding: "30px",
                    dots: true,
                    autoplay: false
                }
            }
        ]
    };
    const slides = [
        {
            title: t('references.slide1.title'),
            text: t('references.slide1.text')
        },
        {
            title: t('references.slide2.title'),
            text: t('references.slide2.text')
        },
        {
            title: t('references.slide3.title'),
            text: t('references.slide3.text')
        },
        {
            title: t('references.slide4.title'),
            text: t('references.slide4.text')
        },
        {
            title: t('references.slide5.title'),
            text: t('references.slide5.text')
        }

    ];
    return (
       <div className="references py-12 md:py-24">
            <div className="container">
                <h2 className="text-center text-4xl sm:text-6xl font-bold mb-4 uppercase"> {t('references.title')} </h2>
                <p className="text-center mb-6 sm:mb-12"> {t('references.description')}</p>
                <Slider {...settings}>
                        {slides.map((slide, index) => (
                            <div key={index} className="px-4">
                                <div className="references-item bg-white p-6 rounded-lg shadow-lg">
                                    <h2 className="text-xl md:text-2xl font-bold mb-4">{slide.title}</h2>
                                    <p className="text-sm md:text-base italic text-gray-600">"{slide.text}"</p>
                                    
                                </div>
                            </div>
                        ))}
                </Slider>
            </div>
       </div>
    )
}